// @ts-check
import { observer } from 'mobx-react';
import React, { Component } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import 'Styles/leftPanel.scss';
import IconsContainer from "Utils/IconsContainer";
import LeftPanelItems from 'Components/LeftPanel/leftPanelItems';
import LeftPanelItemsStats from 'Components/LeftPanel/LeftPanelItemsStats';
import LeftPanelItemsUsersMetrics from 'Components/LeftPanel/LeftPanelItemsUsersMetrics';
import LeftPanelItemsUserMetrics from 'Components/LeftPanel/LeftPanelItemsUserMetrics';

class LeftPanel extends Component {
    /** @param {any} props */
    constructor(props) {
        super(props);

        let width = window.innerWidth ||
            document.documentElement.clientWidth ||
            document.body.clientWidth;

        let openedState = width > 1280;

        this.state = {
            opened: openedState
        }
    }

    ToggleOpenState() {
        this.setState({
            opened: !this.state.opened
        });
    }

    render() {
        return (
            <div className={"left-panel " + (this.state.opened === true ? '' : 'closed')}>
                <Routes>
                    <Route path={'/stats'} element={<LeftPanelItemsStats />} />
                    <Route path={'/usersMetrics'} element={<LeftPanelItemsUsersMetrics />} />
                    <Route path={'/userMetrics'} element={<LeftPanelItemsUserMetrics />} />
                    <Route path={'*'} element={<LeftPanelItems />} />
                </Routes>
                <div
                    className="toggle-left-panel-button"
                    onClick={this.ToggleOpenState.bind(this)}
                >
                    {IconsContainer.Get(this.state.opened === true ? 'lp-toggle-left-panel-button-opened' : 'lp-toggle-left-panel-button-closed')}
                </div>
            </div>
        );
    }
}

export default observer(LeftPanel);